module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/gift-cards_61026b.jpg";